import { Component, OnInit, HostListener } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { API_URLS } from '../../global';
import { DevModeService } from '../../services/dev-mode.service';
import { ZipcodeService } from '../../services/zipcode.service';
import { StateService } from '../../services/state.service';
import { ConfigData, LocateMeData } from '../../models/locate-me-rendering-response';
import { GeolocationService } from '../../services/geolocation.service';
import { UtilsService } from '../../services/utils.service';
import { ProgressBarService } from '../../services/progress-bar.service';

@Component({
  selector: 'dt-zipcode-popover',
  templateUrl: './zipcode-popover.component.html',
  styleUrls: ['./zipcode-popover.component.scss']
})
export class ZipcodePopoverComponent implements OnInit {

  isPopover!: boolean;
  showIcon = true;
  blackStyle = false;
  fixedModalView = false;
  intialZipCode!: string;
  zipcodeForm: any;

  configData!: ConfigData;
  locateMeData!: LocateMeData;
  isOpened = false;
  customEventFlag  : boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly stateService: StateService,
    private readonly geolocationService: GeolocationService,
    private readonly utils: UtilsService,
    private readonly loading: ProgressBarService,

    public zipcodeService: ZipcodeService,
    private devModeService: DevModeService
  ) {
    this.blackStyle = document.location.pathname != '/' && document.getElementById('isHeadlessHome') === null;
  }

  ngOnInit(): void {
    this.zipcodeForm = this.fb.group({
      zipcode: ['', [Validators.required, Validators.minLength(5)]]
    });
    this.initState();
    this.onResize();
    
   document.addEventListener('CLOSE_HEADER_LOCATION_MODAL', () => {
    this.close();
 });

 document.addEventListener('OPEN_HEADER_LOCATION_MODAL', (event) => {
  this.customEventFlag = true;
  this.open(event);
});

  }

  initState() {
    this.stateService.renderingDataSubject.subscribe(async (renderingData) => {
      if (this.utils.extractValueFromObject(renderingData, 'LocateMeData.Success')) {
        this.configData = renderingData.ConfigData;
        this.locateMeData = renderingData.LocateMeData;
        
        this.intialZipCode =   (window as any).AN?.locationService?.getLocation()?.zipCode;     
        this.setZipcodeValue();

        if (this.stateService.zipCodeFromUrl) {
          await this.validateUrlZipcode();
        }

        this.stateService.identifyLocationEvent(this.zipcode?.value);
      }
    });
  }


  async validateUrlZipcode() {

    const zipCode = this.stateService.zipCodeFromUrl;
    const valid = await (window as any).AN?.locationService?.validateZipCode(zipCode);
    if(!valid) {
         this.fixedModalView = true;
        this.onResize();
        this.isOpened = true;

        setTimeout(() => {
          this.zipcode?.setErrors({ invalidZipcode: true });
          this.zipcode?.markAsDirty();
        }, 0);     
    }

  }


  get zipcode(): AbstractControl | null {
    return this.zipcodeForm.get('zipcode');
  }

  get isInvalidZipcode(): boolean | undefined {
    return this.zipcode?.invalid && !this.zipcode.pristine;
  }

  get errorMessage(): string {
    return this.zipcode?.errors?.required ? this.configData?.ZipCodeRequired
      : this.zipcode?.errors?.minlength ? this.configData?.ZipCodeMinLength
        : this.zipcode?.errors?.invalidZipcode ? 'Zipcode you entered is not valid'
          : this.zipcode?.errors?.accesDenied ? 'Browser location is disabled' : '';
  }

  async getZipcode() {
    this.loading.start();
    const wnd = window as any;
    const location = await wnd.AN.locationService.getBrowserLocation();
    this.loading.clear();
    if(location?.error){
      console.log(location.error);
    
      this.setZipcodeValue();
    }
    else {
      this.zipcode?.setValue(location.PostalCode);             
    }

  }
  focusInput() {
    document.dispatchEvent(new CustomEvent("zipcode-modal-FE-events", {
      detail: 'zipInputFocus',
    }));
  }

  updateZipcode(): void {
    document.dispatchEvent(new CustomEvent("zipcode-modal-FE-events", {
      detail: 'updateZipcode',
    }));
    this.loading.start();
    this.zipcodeService.updateZipcode(this.zipcode?.value).subscribe(response => {
      console.log('response update', response);

      if (response.Success) {
        this.stateService.reloadPage(this.zipcode?.value);
      } else {
        this.loading.clear();
      }
      this.loading.clear();
    }, error => {
      console.log(error);
      this.loading.clear();
    });
  }

  close(): void {
    if(this.isOpened) {
      document.dispatchEvent(new CustomEvent("zipcode-modal-FE-events", {
        detail: 'closeZipcode',
      }));
    }
    this.isOpened = false;
    this.toggleScrollbar('auto');
  }

  open(e: Event): void {
    if(this.customEventFlag === true){
      this.fixedModalView = true;
    }else{
      this.fixedModalView = e.isTrusted;
    }
    this.onResize();
    this.setZipcodeValue();
    this.isOpened = true;
    this.toggleScrollbar('hidden');
  }

  setZipcodeValue_obsolete(): void {
    this.zipcode?.setValue(this.locateMeData.PreferredZipCode || this.locateMeData.DefaultZipCode);
  }

  setZipcodeValue(): void {
    const location = (window as any).AN?.locationService?.getLocation();
    if(location?.zipCode){
      this.zipcode?.setValue(location.zipCode); 
    }
  }


  fixPath(iconPath: string): string {
    return this.devModeService.isDevMode() ? API_URLS.LOCAL + iconPath : iconPath;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isPopover = window.innerWidth > 1024 && this.fixedModalView;
  }

  onClickHandle(e: Event) {
    const el = (e.target as Element);
    if (el.nodeName === 'DIV') {
      if (el.className === 'dt-zipcode--modal') {
        this.close();
      }
    }
  }

  toggleScrollbar(state: string) {
    if (this.isPopover == false) document.documentElement.style.overflow = state;
  }

  @HostListener('document:keydown.escape')
  onKeydownHandler() {
    this.close();
  }
}
